var exports = {
  "i": "xa15a2ab7--81623d--wrapper",
};

module.exports = exports;
